import QuestionExpanded from './QuestionExpanded'
export default QuestionExpanded